import { render, staticRenderFns } from "./DashboardPendenciasApuracao.vue?vue&type=template&id=554a6751"
import script from "./DashboardPendenciasApuracao.vue?vue&type=script&lang=js"
export * from "./DashboardPendenciasApuracao.vue?vue&type=script&lang=js"
import style0 from "./DashboardPendenciasApuracao.vue?vue&type=style&index=0&id=554a6751&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports